import type Backbone from 'backbone';
import SearchFormStore from '@ve/pages/serp/store/SearchFormStore';
import { mountLibSearchForm, type MountLibSearchFormResult } from './mountLibSearchForm';

// Для автокомплит-контроллеров вне серпа: стор формы они сами не заводят.
export function mountSeoSearchForm(controller: { model: Backbone.Model; formSubmit(): void }): MountLibSearchFormResult {
    SearchFormStore({ model: controller.model });
    return mountLibSearchForm({ controller, vertical: 'seo' });
}
